import { toast } from 'react-toastify'

import { AppError } from '../components/common/AppError'

type HandleResponseCallback = (r: any) => void

export async function handleResponse(
  response,
  handleErrorCallback: HandleResponseCallback | null = null,
  toastError = true,
) {
  if (response.status === 200 || response.status === 201) {
    return response.data
  }

  if (handleErrorCallback != null) {
    handleErrorCallback(response)
    return
  }

  const error = await response.text()
  handleError(error, toastError)
}

export function handleError(error, toastError = true) {
  if (toastError) {
    toast.error(formatError(error))
  } else {
    const errorCode =
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.errorCode) ||
      100
    throw new AppError({
      name: 'AppError',
      message: formatError(error, false),
      errorCode: errorCode,
      innerError: error,
    })
  }
}

const formatError = (error, withStatusCode = true): string => {
  let errorMessage: string = error.message
  const errorCode =
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errorCode

  if (errorCode) {
    errorMessage = `Please contact your administrator (Error Code: ${errorCode}`
    if (withStatusCode && error.response.status) {
      errorMessage += `, Status Code: ${error.response.status}`
    }
    errorMessage += ').'
  }
  return errorMessage
}
